let deferredPrompt = null;

window.addEventListener('beforeinstallprompt', event => {
  event.preventDefault();
  deferredPrompt = event;
  window.dispatchEvent(new CustomEvent('pwa-install-available'));
});

window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  window.dispatchEvent(new CustomEvent('pwa-install-completed'));
});

export const hasDeferredInstallPrompt = () => !!deferredPrompt;

export const promptInstall = async () => {
  if (!deferredPrompt) return null;

  const promptEvent = deferredPrompt;
  deferredPrompt = null;

  try {
    promptEvent.prompt();
    const { outcome } = await promptEvent.userChoice;
    return outcome;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('PWA install prompt failed:', error);
    return null;
  }
};

export const isRunningStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;
